import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@src/context/authContext";

const Protected = ({ children, allowedUserType = "guest" }) => {
  const { isAuthenticated, hasRole } = useAuthContext();
  const location = useLocation();
  const isAuthorized = hasRole(allowedUserType);
  if (!isAuthenticated) {
    console.debug("unauthenticated");
    const searchParams = new URLSearchParams(location.search);
    const loginTarget = `/login${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    return <Navigate to={loginTarget} state={{ from: location }} />;
  }
  if (!isAuthorized) {
    console.debug("unauthorized");
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default Protected;
